import { render, staticRenderFns } from "./form.vue?vue&type=template&id=0f39b96a"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f39b96a')) {
      api.createRecord('0f39b96a', component.options)
    } else {
      api.reload('0f39b96a', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=0f39b96a", function () {
      api.rerender('0f39b96a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/contact/form.vue"
export default component.exports